import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import SingleFilter from "./filter/singlefilter";
import ResetState from "./resetstate";
import { SelectInput } from ".";

function FilterInput({
  value,
  onChange,
  className,
  resetValue,
  isResetVisible = true,
  maxFilters,
  label = "Filters",
  matchType = "all", // "all" or "any"
  onMatchTypeChange,
  fields = [],
}) {
  const handleDelete = (index) => {
    const oldValues = [...(value ? value : [])];
    oldValues.splice(index, 1);
    onChange(oldValues);
  };

  const addNewFilter = () => {
    if (value && maxFilters && value.length >= maxFilters) return;
    const oldValues = [
      ...(value ? value : []),
      {
        field: fields[0]?.id || "",
        operator: "equals",
        value: "",
      },
    ];
    onChange(oldValues);
  };

  const classes = classnames(
    "grigora-filter text-grigora-base cursor-default border rounded-[6px] mb-2",
    className,
  );

  return (
    <div className={classes}>
      <div className="grigora-filter__title p-2 items-center flex justify-between">
        <span>{label}</span>
        <div className="flex items-center gap-2">
          {value && value.length > 1 && (
            <SelectInput
              isResetVisible={false}
              value={matchType}
              onChange={onMatchTypeChange}
              options={[
                { label: "Match All", value: "all" },
                { label: "Match Any", value: "any" },
              ]}
              className="!mb-0"
            />
          )}
          <FontAwesomeIcon
            onClick={addNewFilter}
            icon={faPlus}
            className="grid p-2 cursor-pointer"
          />
        </div>
      </div>
      <div className="grigora-filter__items">
        {value &&
          Array.isArray(value) &&
          value.map((item, index) => {
            return (
              <SingleFilter
                fields={fields}
                onDelete={() => {
                  handleDelete(index);
                }}
                key={index}
                value={item}
                index={index}
                onChange={(e) => {
                  var temp = [...(value ? value : [])];
                  temp[index] = e;
                  onChange(temp);
                }}
              />
            );
          })}
      </div>
    </div>
  );
}

export default FilterInput;
